interface ISubmissionCellProps {
  imageUrl: string
  title: string
  description: string
  deniedReason?: string
  timestamp: string
  onClick?: () => void
}

export const SubmissionCell = (props: ISubmissionCellProps) => {
  return (
    <div
      className={
        'flex gap-3 md:gap-4 py-4 md:py-8 px-4 md:px-8 items-center border-b border-searchBorder cursor-pointer hover:bg-gray-50 transition-colors relative'
      }
      onClick={props.onClick}
    >
      {/* Image */}
      <img
        src={props.imageUrl}
        alt={props.title}
        className={'w-16 h-16 md:w-24 md:h-24 object-cover rounded-lg flex-shrink-0'}
      />

      {/* Content - flexible width */}
      <div className={'flex-1 min-w-0 pr-16 md:pr-0'}>
        {/* Title */}
        <h3 className={'text-base md:text-lg font-semibold mb-1 md:mb-2'}>{props.title}</h3>

        {/* Description - limited to 3 lines */}
        <p className={'text-sm text-gray-600 line-clamp-3'}>
          {props.description}
        </p>

        {/* Denied Reason - only shown if available */}
        {props.deniedReason && (
          <p className={'text-sm text-red-600 mt-2 font-medium'}>
            Denied: {props.deniedReason}
          </p>
        )}
      </div>

      {/* Timestamp in top right corner of cell */}
      <div className={'absolute top-4 right-4 md:right-8 text-xs md:text-sm text-gray-500'}>
        {props.timestamp}
      </div>
    </div>
  )
}
